export default __webpack_public_path__ + "static/media/foreign-language-card.320b2ae2.webp";